<template>
  <div class="live_stream_container" v-show="listData && listData.length > 0">
    <CardTitle :title="data.title" skipPage="/liveStream" />

    <div class="list_wrapper" v-if="isSmallList">
      <template v-for="item in listData" :key="item.id">
        <div class="list_item" @click="watchLiveStream(item)">
          <div class="item_img">
            <img class="img" :src="item.coverFileUrl" v-if="item.coverFileUrl" />
            <img class="img" src="@/assets/images/live_stream.jpg" v-else />
          </div>

          <div class="item_content">
            <p class="content_title">{{ item.name }}</p>
            <p class="content_author">{{ item.lecturerName }}</p>
            <p class="content_time">{{ item.startTime }}</p>
          </div>

          <span class="item_btn" v-if="item.status === 1 || item.status === 2">
            {{ $t('app_live_stream_watch') }}
          </span>
          <!-- 回放 -->
          <span class="item_btn item_btn1" v-if="item.status === 3 && item.isAllowPlayback === 1 && item.coursewareId">
            {{ $t('app_live_stream_playback') }}
          </span>
          <!-- 回访生成中 -->
          <span class="item_btn item_btn2" v-if="item.status === 3 && !item.coursewareId">
            {{ $t('app_live_stream_playback') }}
          </span>
        </div>
      </template>
    </div>

    <div class="list_wrapper1" v-if="isBigList || isGridList">
      <div
        class="list_item"
        :class="{ full: isBigList }"
        v-for="item in listData"
        :key="item.id"
        @click="clickHandle(item)"
      >
        <div class="item_img">
          <img class="img" :src="item.coverFileUrl" v-if="item.coverFileUrl" />
          <img class="img" src="@/assets/images/live_stream.jpg" v-else />
        </div>

        <div class="item_content">
          <p class="content_title">{{ item.name }}</p>
          <p class="content_author">
            {{ item.lecturerName }}
          </p>
          <p class="content_author content_author1">
            {{ item.startTime }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import CardTitle from './CardTitle.vue'
import { useThemeColor } from '@/utils/theme'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useRouter } from 'vue-router'
import { Record } from '@/api/Models/LiveRoomList'
import { getLivestreamRedirect } from '@/api/requests/LiveStream'
import { showToast } from 'vant'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  data: LmsDecorateModule
}>()

const themeColor = useThemeColor()
const { t } = useI18n()
const router = useRouter()

// 直播/回放/回放生成中
const watchLiveStream = async (item: Record) => {
  const isPlayback = item.status === 3 && item.coursewareId
  const isPlaybackGenerating = item.status === 3 && !item.coursewareId
  const isLiveStream = item.status === 1 || item.status === 2
  if (isLiveStream) {
    router.push({ name: 'live', query: { watchUrl: item.watchUrl } })
  }
  try {
    const res = await getLivestreamRedirect({
      id: item.id,
      type: 0
    })
    if (res) {
      if (isPlayback) {
        if (item.isAllowPlayback === 1) {
          // 回放状态 跳转课件
          router.push({
            name: 'courseDetail',
            query: {
              id: item.coursewareId,
              courseType: 'courseWare',
              channel: 5,
              title: item.name
            }
          })
          return
        }
      }
      if (isPlaybackGenerating) {
        if (item.isAllowPlayback === 1) {
          showToast(t('app_live_stream_replay_generation'))
          return
        }
        if (item.isAllowPlayback === 0) {
          return
        }
      }
    } else {
      // 你还没有该直播间的访问权限，请向管理员申请
      showToast(t('app_no_live_stream_permission'))
      router.replace({ path: '/empty', query: { msg: t('app_no_live_stream_permission') } })
    }
  } catch (error) {
    console.log(error, 'error')
  }
}
const clickHandle = (item: Record) => {
  watchLiveStream(item)
}

const listData = computed(() => {
  try {
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})
const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).layoutType
  } catch (error) {
    return 1
  }
})
const isSmallList = computed(() => type.value === 1)
const isBigList = computed(() => type.value === 2)
const isGridList = computed(() => type.value === 3)
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');

.live_stream_container {
  margin: 12px 16px;
  padding: 0 12px;
  background-color: @contentBackground;
  border-radius: 8px;
  overflow: hidden;
  .list_wrapper {
    .list_item {
      padding: 14px 0;
      display: flex;
      align-items: center;
      .border_1px_b;
      .item_img {
        width: 96px;
        height: 54px;
        border-radius: 5px;
        overflow: hidden;
        .flex_center;
        .img {
          width: 100%;
        }
      }
      .item_content {
        flex: 1;
        margin-left: 10px;
        .content_title {
          font-size: 14px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          word-break: break-all; /* 添加换行规则 */
        }
        .content_author {
          color: @textNormal;
          font-size: 12px;
        }
        .content_time {
          margin-top: 4px;
          color: @textSecondary99;
          font-size: 12px;
        }
      }
      .item_btn {
        width: 61px;
        height: 28px;
        background-color: v-bind(themeColor);
        border-radius: 28px;
        .flex_center;
        color: @textWhite;
        font-size: 13px;
      }
      .item_btn1 {
        background-color: #f4f5f7;
        border: 1px solid v-bind(themeColor);
        color: v-bind(themeColor);
      }
      .item_btn2 {
        background-color: #f4f5f7;
        color: #999999;
      }
    }
  }
  .list_wrapper1 {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    .list_item {
      width: calc((100vw - 32px - 24px - 10px) / 2);
      margin-top: 10px;
      &.full {
        width: calc(100vw - 32px - 24px);
        margin-left: 0 !important;
        .item_img {
          height: calc((100vw - 32px - 24px) * 0.58);
        }
      }
      &:nth-child(even) {
        margin-left: 10px;
      }
      .item_img {
        width: 100%;
        height: calc((100vw - 32px - 24px - 10px) / 2 * 0.58);
        border-radius: 5px;
        overflow: hidden;
        .flex_center;
        .img {
          width: 100%;
        }
      }
      .item_content {
        .content_title {
          margin-top: 5px;
          font-size: 14px;
          .text_etc;
        }
        .content_author {
          margin-top: 4px;
          color: @textNormal;
          font-size: 12px;
          .text_etc;
        }
        .content_author1 {
          margin-top: 0;
        }
        .content_time {
          color: @textSecondary99;
          font-size: 12px;
        }
      }
      .item_btn {
        width: 61px;
        height: 28px;
        background-color: v-bind(themeColor);
        border-radius: 28px;
        .flex_center;
        color: @textWhite;
        font-size: 13px;
      }
      .item_btn1 {
        background-color: #f4f5f7;
        border: 1px solid v-bind(themeColor);
      }
      .item_btn2 {
        background-color: #f4f5f7;
        color: #999999;
      }
    }
  }
}
</style>
